import React from 'react';

// Services
import { colorCellPharmacy, getRescueDose } from '../../../services/Pharmacy';
// Hooks
import { useState } from 'react';

// Components
import TakenDialog from '../TakenDialog/TakenDialog';
import Modal from '../../UI/Modal/Modal';
import Tooltip from '../../UI/Tooltip/Tooltip';

// Interfaces
import { DrugAdministration, DrugAdministrationBody, DrugAdministrationList } from '../../../interfaces/Drug';
import NoteCell from '../../UI/NoteCell/NoteCell';

const CellContent: React.FC<{
    date: string,
    hour: string,
    drug: DrugAdministrationList,
    readOnly: boolean
    handleSetDrugs: (updateDrugs: (oldDrugs: DrugAdministrationList[]) => DrugAdministrationList[]) => void
}> = ({ date, hour, drug, readOnly, handleSetDrugs }) => {

    const [showTakenDialog, setShowTakenDialog] = useState<boolean>(false);
    const [time, setTime] = useState<{ date: string, hour: string }>({ date: '', hour: '' });

    const handleClickCell = (date: string, hour: string) => {
        setShowTakenDialog(true);
        setTime({ date, hour });
    };

    const handleConfirmTaken = (body: DrugAdministrationBody) => {
        const updateDrugs = (oldDrugs: DrugAdministrationList[]) => {
            const newDrugs = [...oldDrugs];
            return newDrugs.map(newDrug => {
                if (newDrug.drugId === drug.drugId) {
                    newDrug.hours[time.hour][time.date][0].rescue_dose = body.rescue_dose;
                    newDrug.hours[time.hour][time.date][0].rescue_dose_number = body.rescue_dose_number;
                    newDrug.hours[time.hour][time.date][0].status = body.status;
                    newDrug.hours[time.hour][time.date][0].cancellation_reason = body.cancellation_reason;
                }
                return newDrug;
            });
        };
        handleSetDrugs(updateDrugs);
    };

    const renderRescueDose = (drugAdmins: DrugAdministration[]) => {
        const rescueDoses = getRescueDose(drugAdmins);
        if (rescueDoses === 0) return '';
        else return `(+${rescueDoses})`;
    };


    const deleted = Boolean(drug.hours?.[hour]?.[date]?.[0]?.deleted_at ?? false);
    const clickable = !readOnly && !deleted;


    return (
        <>
            {drug.hours[hour][date] ?

                <td onClick={clickable ? () => handleClickCell(date, hour) : undefined}
                    className={`pharmaCell ${clickable ? 'clickable' : ''} ${colorCellPharmacy(deleted, drug.hours[hour][date][0].status)}`}
                >
                    {drug.hours[hour][date][0].status === 'cancelled' && drug.hours[hour][date][0].cancellation_reason ?
                        <NoteCell pos={{right: 4}}>
                            <Tooltip text={drug.hours[hour][date][0].cancellation_reason || ''}>
                                <div className='note'></div>
                            </Tooltip>
                        </NoteCell>
                        : null
                    }
                    <p>{drug.hours[hour][date][0].drug_dose_amount} {drug.hours[hour][date][0].drug_dose_unit || ''} <span style={{ fontWeight: 'bold' }}>{renderRescueDose(drug.hours[hour][date])}</span></p>
                </td>
                :
                <td className='pharmaCell grayCell'></td>
            }
            {hour && drug.hours[hour][time.date] && <Modal show={showTakenDialog} setShowModal={setShowTakenDialog}>
                <TakenDialog
                    drugName={drug.drugName}
                    administrations={drug.hours[hour][time.date]}
                    time={time}
                    showDialog={setShowTakenDialog}
                    administrationID={drug.hours[hour][time.date][0].id}
                    handleConfirmTaken={handleConfirmTaken}
                />
            </Modal>}
        </>
    );
};

export default CellContent;
